export type CompareResult = -1 | 0 | 1;

/**
 * Если left < right, то result -1
 * Если left > right, то result 1
 * Если left == right, то result 0
 *
 * По сути это Math.sign(left - right).
 */
export type CompareFunc<T> = (left: T, right: T) => CompareResult;

export function strictSign(value: number): CompareResult {
    if (typeof value !== "number") {
        throw new TypeError("Value must be number");
    }
    if (value > 0) {
        return 1 as const;
    }
    if (value < 0) {
        return -1 as const;
    }
    return 0 as const;
}

export function compareNumbers(left: number, right: number): CompareResult {
    return strictSign(left - right);
}

export class ComparerDecorators {
    public static undefinedOrNullAsMax<T>(inComparer: CompareFunc<T>): CompareFunc<T | undefined | null> {
        return (left: T | undefined | null, right: T | undefined | null): CompareResult => {
            if (left == undefined && right == undefined) {
                return 0;
            }
            if (left == undefined) {
                return 1;
            }
            if (right == undefined) {
                return -1;
            }
            return inComparer(left, right);
        };
    }

    public static undefinedOrNullAsMin<T>(inComparer: CompareFunc<T>): CompareFunc<T | undefined | null> {
        return (left: T | undefined | null, right: T | undefined | null): CompareResult => {
            if (left == undefined && right == undefined) {
                return 0;
            }
            if (left == undefined) {
                return -1;
            }
            if (right == undefined) {
                return 1;
            }
            return inComparer(left, right);
        };
    }
}
